import useHttpQuery from 'data/firestore/useHttpQuery';
import {
    buildWebhookLogByIdSearchBody,
    buildWebhookLogsSearchPath,
} from './helpers/buildSearchBody';
import formatWebhookLogFromElasticsearch from './helpers/formatWebhookLogFromElasticsearch';
import {
    GetWebhookLogQuery,
    SearchWebhookLogsResponse,
    WebhookLog,
} from './types';

interface UseWebhookLogResult {
    data?: WebhookLog;
    isLoading: boolean;
    error: unknown;
}

const useWebhookLog = ({
    agentId = '',
    webhookId = '',
    logId = '',
    queryOptions = { enabled: true },
}: GetWebhookLogQuery): UseWebhookLogResult => {
    const enabled = Boolean(
        queryOptions.enabled !== false
        && agentId
        && logId,
    );

    const { data, isLoading, error } = useHttpQuery<SearchWebhookLogsResponse>({
        key: [
            'webhook-log',
            agentId,
            webhookId,
            logId,
        ],
        pathname: buildWebhookLogsSearchPath(agentId),
        method: 'POST',
        server: process.env.REACT_APP_BASE_URL,
        body: buildWebhookLogByIdSearchBody({
            logId,
            webhookId: webhookId || undefined,
        }),
        queryOptions: {
            ...queryOptions,
            enabled,
        },
    });

    const hit = data?.hits?.[0];

    return {
        data: hit ? formatWebhookLogFromElasticsearch(hit) : undefined,
        isLoading: isLoading || (enabled && !data),
        error,
    };
};

export default useWebhookLog;
